import styles from "../../page.module.css";

import { inject, observer } from "mobx-react";
import { ClientOverviewStore, ViewType } from "../../store/store";
import { ViewItem, ViewSwitch } from "../../../../components/view-switch";
import CardViewGrid from "../card-view-grid/CardViewGrid";
import { CARD_TYPES } from "../card-view-grid/card-item/card-item";
import webResource from "../../web";
import { AlertDataConverter } from "../../store/convertor";
import { AlertDataIn } from "../../store/typesIn";
import AlertOverviewGrid from "../alert-overview-grid/AlertOverviewGrid";
import { useEffect } from "react";
import LocationSelectorStore from "../../../../store/location-selector-store";
import UserSettingsStore, {
    SortSettings,
    UserSettings,
} from "../../../../store/user-settings";

export interface ResidentStatusTabProps {
    clientOverviewStore?: ClientOverviewStore;
    locationSelectorStore?: LocationSelectorStore;
    userSettingsStore?: UserSettingsStore;
}

function ResidentStatusTab(props: ResidentStatusTabProps) {
    const clientOverviewStore = props.clientOverviewStore!;
    const locationSelectorStore = props.locationSelectorStore!;
    const userSettingsStore = props.userSettingsStore!;

    const { requestIds } = locationSelectorStore;
    const sortOptions = userSettingsStore.getUserSetting(
        SortSettings.ALARM_OVERVIEW
    );

    useEffect(() => {
        fetchData();
    }, [sortOptions, requestIds]);

    const fetchData = () => {
        clientOverviewStore.setIsDataLoading(true);

        const sortOptions = userSettingsStore.getUserSetting(
            SortSettings.ALARM_OVERVIEW
        );
        
        const payload = {
            FilteredLocationIds: requestIds,
            SortOptions: [sortOptions],
        };

        return webResource.readAlertSettings(payload).then((response) => {
            const alertList = response.data?.data.map((alert: AlertDataIn) => {
                return AlertDataConverter.toStore(alert);
            });

            clientOverviewStore.alertSettingsList = alertList!;

            clientOverviewStore.setIsDataLoading(false);

            setTimeout(() => {
                const selectedClientElement =
                    document.querySelector("#selected-client");
                if (selectedClientElement) {
                    selectedClientElement.scrollIntoView({
                        behavior: "smooth",
                        block: "nearest",
                        inline: "start",
                    });
                }
            });
        });
    };

    const render = () => {
        return (
            <ViewSwitch
                activeKey={userSettingsStore.getUserSetting(
                    UserSettings.RESIDENT_VIEW_TYPE
                )}
            >
                <ViewItem itemKey={[ViewType.LIST]}>
                    <div className={styles["overflow-content"]}>
                        <AlertOverviewGrid />
                    </div>
                </ViewItem>
                <ViewItem itemKey={[ViewType.GRID]}>
                    <div className={styles["overflow-content"]}>
                        <CardViewGrid cardType={CARD_TYPES.Alert} />
                    </div>
                </ViewItem>
            </ViewSwitch>
        );
    };

    return render();
}

export default inject(
    "clientOverviewStore",
    "locationSelectorStore",
    "userSettingsStore"
)(observer(ResidentStatusTab));
